import React from 'react';
import '../styles/Home.css';

const Home = () => (
  <>
    <section className=" container home-section">
      <h2>Welcome to our page!</h2>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas eius,
        dolorum ipsum consequatur nostrum eaque aut repellat id in non ut
        numquam? Nobis beatae mollitia sapiente esse perferendis libero nulla.
        Lorem ipsum dolor sit, amet consectetur adipisicing elit. Accusantium
        reiciendis molestias, earum a ab cumque totam! Minima praesentium
        deserunt earum, doloribus sequi modi ratione alias eum voluptates
        similique blanditiis vel!
      </p>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam excepturi
        alias, tempora id possimus blanditiis laudantium laboriosam inventore
        nam explicabo hic placeat eum, voluptatem amet aliquid mollitia
        molestiae cum? Lorem ipsum dolor sit amet, consectetur adipisicing elit.
        Quae nam nobis fugiat tempore tempora, nulla explicabo fuga perferendis
        eveniet esse molestiae earum. Non accusantium unde, veniam sit deleniti
        quis ut.
      </p>
    </section>
  </>
);

export default Home;
